export const SWITCH_SLIDEOUT = 'SWITCH_SLIDEOUT';
